import { Check, Copy } from 'lucide-react';
import { cn } from '@shared/lib/utils';

interface CopyFeedbackIconProps {
  copied?: boolean;
  className?: string;
}

/** Swap copy → green check with a short transition (pair with useCopyToClipboard / local copied state). */
export function CopyFeedbackIcon({ copied = false, className }: CopyFeedbackIconProps) {
  return (
    <span className={cn('relative inline-flex size-4 shrink-0 items-center justify-center', className)}>
      <Copy
        aria-hidden
        className={cn(
          'size-full transition-all duration-200 ease-standard',
          copied ? 'scale-75 opacity-0' : 'scale-100 opacity-100',
        )}
      />
      <Check
        aria-hidden
        className={cn(
          'absolute inset-0 size-full text-emerald-500 transition-all duration-200 ease-standard',
          copied ? 'scale-100 opacity-100' : 'scale-75 opacity-0',
        )}
      />
    </span>
  );
}
